import React from "react";
import {
  HomepageProps,
  SharedProps,
  Layout,
  TwoColumnProps,
  TwoColumnVideoProps,
  TwoColumnAssetProps,
  GridProps,
  CampaignProps
} from "./types";
import Generic from "./_Generic";
import Homepage from "./_Homepage";
import TwoColumn from "./_TwoColumn";
import TwoColumnVideo from "./_TwoColumnVideo";
import TwoColumnAsset from "./_TwoColumnAsset";
import Grid from "./_Grid";
import Campaign from "./_Campaign";

type Props =
  | ({
      layout?: "curve";
    } & SharedProps)
  | ({
      layout: "homepage";
    } & HomepageProps)
  | ({
      layout: "two-column";
    } & TwoColumnProps)
  | ({
      layout: "two-column-video";
    } & TwoColumnVideoProps)
  | ({
      layout: "two-column-asset";
    } & TwoColumnAssetProps)
  | ({
      layout: "grid";
    } & GridProps)
  | ({
      layout: "campaign-left";
    } & Omit<CampaignProps, "align">)
  | ({
      layout: "campaign-right";
    } & Omit<CampaignProps, "align">);

const levelToComponentMap: Record<Layout, React.ElementType> = {
  curve: Generic,
  homepage: Homepage,
  "two-column": TwoColumn,
  "two-column-video": TwoColumnVideo,
  "two-column-asset": TwoColumnAsset,
  grid: Grid,
  "campaign-left": Campaign,
  "campaign-right": Campaign
};

const Hero = ({ layout = "curve", ...rest }: Props) => {
  const HeroComponent = levelToComponentMap[layout];

  if (HeroComponent === Campaign) {
    return (
      <HeroComponent
        align={layout === "campaign-left" ? "left" : "right"}
        {...rest}
      />
    );
  }

  return <HeroComponent {...rest} />;
};

export default Hero;
